export default "__VITE_ASSET__CUOieTfJ__"